<template>
  <d-modal
    :active="isActive"
    :width="600"
    @close="handleClose"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <div class="p-6">
      <!-- Header -->
      <div class="mb-6">
        <h3 class="text-xl font-semibold text-secondary-500">
          {{ subjectArea.name }}
        </h3>
        <h2 class="text-4xl font-bold">
          {{ category ? 'Update Category' : 'Add Category' }}
        </h2>
      </div>

      <!-- Form -->
      <form @submit.prevent="saveForm" class="space-y-4">
        <!-- Name Field -->
        <d-field label="Name">
          <d-input v-model="form.name" required />
        </d-field>

        <!-- Icon Field -->
        <d-field label="Icon">
          <font-icon-selector v-model="form.imageUrl" required />
        </d-field>

        <!-- Loading State -->
        <div v-if="saving" class="flex justify-center py-4">
          <span class="loading loading-spinner loading-md"></span>
        </div>

        <!-- Form Actions -->
        <div class="flex justify-end gap-3 pt-4">
          <d-btn 
            type="button"
            flat 
            @click="handleClose"
          >
            Cancel
          </d-btn>
          <d-btn 
            type="submit"
            color="primary"
            :disabled="saving"
            :loading="saving"
          >
            {{ category ? 'Update Category' : 'Add Category' }}
          </d-btn>
        </div>
      </form>
    </div>
  </d-modal>
</template>

<script>
import axios from 'axios';
import { showErrorToast } from '@services/errorHandling.service';

export default {
  name: 'CategoryModal',
  
  props: {
    active: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      default: () => ({}),
    },
    subjectArea: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      saving: false,
      form: {
        name: '',
        imageUrl: '',
      },
    };
  },

  computed: {
    isActive() {
      return this.active;
    }
  },

  watch: {
    active(newVal) {
      if (newVal) {
        this.resetForm();
      }
    },

    category: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.form = JSON.parse(JSON.stringify(newVal));
        } else {
          this.resetForm();
        }
      },
      immediate: true
    }
  },

  methods: {
    resetForm() {
      if (this.category && this.category.id) {
        this.form = JSON.parse(JSON.stringify(this.category));
      } else {
        this.form = {
          name: '',
          imageUrl: '',
        };
      }
    },

    async saveForm() {
      this.saving = true;
      try {
        if (this.category && this.category.id) {
          await axios.patch(`/api/subject-areas/categories/${this.form.id}`, this.form);
        } else {
          const { data } = await axios.post(`/api/subject-areas/${this.subjectArea.id}/categories/`, this.form);
          this.form.id = data.id;
        }
        this.$emit('saved');
        this.handleClose();
      } catch (error) {
        showErrorToast(error);
      } finally {
        this.saving = false;
      }
    },

    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
/* Remove any potential duplicate styling that might cause ghost outlines */
</style>